var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "导出记录",
        footer: null,
        width: "900px",
        destroyOnClose: true,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("JeepayTable", {
        attrs: {
          tableColumns: _vm.columns,
          reqTableDataFunc: _vm.reqTableDataFunc,
          initData: true,
          searchData: {},
          rowKey: "createdAt",
          tableRowCrossColor: true,
          pageSize: 10,
        },
        scopedSlots: _vm._u([
          {
            key: "statusSlot",
            fn: function ({ record }) {
              return [
                record
                  ? _c(
                      "a-tag",
                      {
                        attrs: {
                          color: _vm.getExportStatusColor(record.status),
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getExportStatusText(record.status)) +
                            " "
                        ),
                      ]
                    )
                  : _c("span", [_vm._v("--")]),
              ]
            },
          },
          {
            key: "createdAtSlot",
            fn: function ({ record }) {
              return [
                record
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.formatTimestamp(record.createdAt))),
                    ])
                  : _c("span", [_vm._v("--")]),
              ]
            },
          },
          {
            key: "actionSlot",
            fn: function ({ record }) {
              return [
                _c(
                  "a-button",
                  {
                    attrs: {
                      disabled:
                        !record || !record.ossAddress || record.status !== 1,
                      type: "link",
                      icon: "download",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.openDownloadFile(
                          record.bizId,
                          record.fileName
                        )
                      },
                    },
                  },
                  [_vm._v(" 下载 ")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }